module.exports = [
    {
        questionText: 'A pandemic is ________',
        questionType: 'multiple-choice',
        choices: [
            'a group of irrational people.',
            'global outbreak of disease',
            'an untreatable condition',
            'a panic disorder'
        ],
        answerId: 1,
        sourceUrl: 'https://www.cdc.gov/coronavirus/2019-ncov/cases-updates/summary.html#covid19-pandemic'
    },
    {
        questionText: 'Coronaviruses are zoonotic, meaning they are _______',
        questionType: 'multiple-choice',
        choices: [
            'a disease that normally exists in animals but that can infect humans',
            'global outbreaks',
            'untreatable',
            '100% fatal'
        ],
        answerId: 0,
        sourceUrl: 'https://www.medicinenet.com/script/main/art.asp?articlekey=12958'
    },
    {
        questionText: 'What does the "corona" in coronavirus mean?',
        questionType: 'multiple-choice',
        choices: [
            'The virus surface is covered with crown-like spikes on their surface',
            'Transmission occurs through sharing of Mexican beer',
            'The virus is designated by the WHO as the king of viruses'
        ],
        answerId: 0,
        sourceUrl: 'https://www.merriam-webster.com/dictionary/coronavirus'
    },
    {
        questionText: 'As of March 22, 2020, there is no vaccine for the coronavirus that causes COVID-19.',
        questionType: 'boolean',
        answerId: 0,
        sourceUrl: 'https://www.livescience.com/can-coronavirus-be-cured.html'
    },
    {
        questionText: 'What is a novel virus?',
        questionType: 'multiple-choice',
        choices: [
            'A virus never seen before',
            'A story about a virus',
            'A virus novel you\'re sick of reading'
        ],
        answerId: 0,
        sourceUrl: 'https://en.wikipedia.org/wiki/Novel_virus'
    },
    {
        questionText: 'What does the acronym SARS stand for?',
        questionType: 'multiple-choice',
        choices: [
            'Shoulda Ate Roasted Steak',
            'Severe Acute Respiratory Syndrome',
            'Simple Acute Renal Syndrome'
        ],
        answerId: 1,
        sourceUrl: 'https://www.nature.com/articles/s41564-020-0695-z'
    },
    {
        questionText: 'The CoVID-19 virus was most likely transmitted from an animal to a human through a "wet market" in the Wuhan Province of China.  What is a "wet market"?',
        questionType: 'multiple-choice',
        choices: [
            'A market selling live meat, fish, produce, and other perishable goods',
            'An underwater strip club or bordello',
            'A farmer\'s market held outdoors in the rain'
        ],
        answerId: 0,
        sourceUrl: 'https://en.wikipedia.org/wiki/Wet_market'
    },
    {
        questionText: 'What is an outbreak?',
        questionType: 'multiple-choice',
        choices: [
            'Escape from a minimally-secured prison due to health concerns',
            'A sudden increase in occurrences of a disease in a particular time and place',
            'The minimum distance people should maintain between each other to avoid spread of disease'
        ],
        answerId: 1,
        sourceUrl: 'https://en.wikipedia.org/wiki/Disease_outbreak'
    },
    {
        questionText: 'What is social distancing?',
        questionType: 'multiple-choice',
        choices: [
            'Actions humans can take or avoid to decrease the transmission of disease',
            'Visiting a crowded beach and lowering the curve',
            'Excessive drinking in the close company of like-minded people'
        ],
        answerId: 0,
        sourceUrl: 'https://en.wikipedia.org/wiki/Social_distancing'
    },
    {
        questionText: 'Which of the following is not an example of social distancing?',
        questionType: 'multiple-choice',
        choices: [
            'Mouth kissing your Tinder date',
            'Not leaving your house unless necessary',
            'Avoiding handshakes',
            'Maintaining six feet of space around you while waiting in a breadline',
            'A Zoom meeting over the internet with 100 of your closest fans'
        ],
        answerId: 0,
        sourceUrl: ''
    },
    {
        questionText: '______ is the capital of Hubei province, People\'s Republic of China',
        questionType: 'multiple-choice',
        choices: [
            'Wu Kang',
            'Hanwu',
            'Wuhan'
        ],
        answerId: 2,
        sourceUrl: 'https://en.wikipedia.org/wiki/Wuhan'
    },
    {
        questionText: 'Common signs of infection include respiratory symptoms, fever, cough, shortness of breath and breathing difficulties.',
        questionType: 'boolean',
        answerId: 0,
        sourceUrl: 'https://www.who.int/docs/default-source/inaugural-who-partners-forum/coronavirus-poster-english-srilanka.pdf?sfvrsn=289dedc3_0'
    },
    {
        questionText: 'Which of the following is not a Coronavirus symptom?',
        questionType: 'multiple-choice',
        choices: [
            'fever',
            'cough',
            'shortness of breath',
            'breathing difficulties',
            'broken arm'
        ],
        answerId: 4,
        sourceUrl: 'https://www.cdc.gov/coronavirus/2019-ncov/symptoms-testing/symptoms.html'
    },
    {
        questionText: 'The virus is primarily spread between people similar to influenza, via respiratory droplets from coughing and sneezing',
        questionType: 'boolean',
        answerId: 0,
        sourceUrl: 'https://www.cdc.gov/coronavirus/2019-ncov/faq.html#How-COVID-19-Spreads'
    },
    {
        questionText: 'What is the definition of quarantine?',
        questionType: 'multiple-choice',
        choices: [
            'Spread a disease',
            'Isolate people or locations',
            'Have a party',
            'Go out in public',
            'Stock up on canned goods',
            'Ignore the news'
        ],
        answerId: 1,
        sourceUrl: 'https://www.dictionary.com/browse/quarantine'
    },
    {
        questionText: 'COVID-19 virus can be transmitted in areas with hot and humid climates',
        questionType: 'boolean',
        answerId: 0,
        sourceUrl: 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019/advice-for-public/myth-busters#climate'
    },
    {
        questionText: 'Taking a hot bath can help prevent the new coronavirus disease',
        questionType: 'boolean',
        answerId: 1,
        sourceUrl: 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019/advice-for-public/myth-busters#bath'
    }, {
        questionText: 'Are hand dryers effective in killing the new coronavirus?',
        questionType: 'boolean',
        answerId: 1,
        sourceUrl: 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019/advice-for-public/myth-busters#hand-dryers'
    }, {
        questionText: 'Antibiotics are effective in preventing and treating the new coronavirus',
        questionType: 'boolean',
        answerId: 1,
        sourceUrl: 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019/advice-for-public/myth-busters'
    }, {
        questionText: 'A vaccine to cure COVID-19 is available',
        questionType: 'boolean',
        answerId: 1,
        sourceUrl: ''
    }, {
        questionText: 'The new coronavirus was first identified on December 31st, 2019.',
        questionType: 'boolean',
        answerId: 0,
        sourceUrl: ''
    }, {
        questionText: 'The World Health Organization declared the outbreak a public health emergency of international concern on January 30th, 2020.',
        questionType: 'boolean',
        answerId: 0,
        sourceUrl: ''
    },
    {
        questionText: 'When did Italian Prime Minister Giuseppe Conte announced that the whole country of Italy is on lockdown?',
        questionType: 'multiple-choice',
        choices: [
            'December 19th, 2020',
            'January 1st, 2020',
            'March 9th, 2020'
        ],
        answerId: 2,
        sourceUrl: 'https://edition.cnn.com/2020/03/09/europe/coronavirus-italy-lockdown-intl/index.html'
    },
    {
        questionText: 'HIV causes AIDS.  Similarly, SARS-CoV-2 causes _______',
        questionType: 'multiple-choice',
        choices: [
            'COVID-2',
            'VODIC-99',
            'VICODIN',
            'COVID-19'
        ],
        answerId: 3,
        sourceUrl: 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019/technical-guidance/naming-the-coronavirus-disease-(covid-2019)-and-the-virus-that-causes-it'
    },
    {
        questionText: 'The official name of the virus responsible for COVID-19 was once known as ______',
        questionType: 'multiple-choice',
        choices: [
            'The end of the world',
            '2019 novel coronavirus',
            '2020 novel modelovirus'
        ],
        answerId: 1,
        sourceUrl: ''
    }, {
        questionText: 'Which of the following is not a human coronavirus?',
        questionType: 'multiple-choice',
        choices: [
            'CARS-CoV',
            'OC43',
            'SARS-CoV',
            'MERS-CoV',
            '229E',
            'SARS-CoV-2'
        ],
        answerId: 0,
        sourceUrl: 'https://www.newscientist.com/term/coronavirus/'
    }, {
        questionText: '2 out of 10 deaths reported in the U.S. have been in adults 65 years old and older.',
        questionType: 'boolean',
        answerId: 1,
        sourceUrl: 'https://www.cdc.gov/coronavirus/2019-ncov/need-extra-precautions/older-adults.html'
    }, {
        questionText: 'Loss of taste or smell is a symptom of COVID-19.',
        questionType: 'boolean',
        answerId: 0,
        sourceUrl: 'https://www.cdc.gov/coronavirus/2019-ncov/symptoms-testing/symptoms.html'
    }, {
        questionText: 'What is "herd immunity"?',
        questionType: 'multiple-choice',
        choices: [
            'Cows separating themselves by at least 12 feet',
            'A drum circle used to ward off evil spirits',
            'A loud noise that prevents Coronavirus infection',
            'A large percentage of the population is immune to infection, preventing or slowing disease spread'
        ],
        answerId: 3,
        sourceUrl: 'https://en.wikipedia.org/wiki/Herd_immunity'
    }, {
        questionText: 'What does the acronym "CDC" stand for?',
        questionType: 'multiple-choice',
        choices: [
            'Centers for Disease Control and Prevention',
            'Cool Disease Company',
            'Corona Defense Commission',
            'Crazy Death Count'
        ],
        answerId: 0,
        sourceUrl: 'https://wwwn.cdc.gov/eWorld/Appendix/Abbreviations'
    },
    {
        questionText: 'What does the term "contact tracing" mean?',
        questionType: 'multiple-choice',
        choices: [
            'A map of government-sanctioned parks and beaches open to the public',
            'Identification, warning, and education of individuals who have had close contact with an infected person',
            'An art project that uses UV light to generate a picture of a virus\'s shape'
        ],
        answerId: 1,
        sourceUrl: 'https://www.cdc.gov/coronavirus/2019-ncov/php/principles-contact-tracing.html'
    },
    {
        questionText: 'What does the term "asymptomatic" mean?',
        questionType: 'multiple-choice',
        choices: [
            'When a patient does not have a disease but several symptoms indicating infection',
            'Infected person only shows a single symptom',
            'When a patient is a carrier of a disease but does not show symptoms of infection'
        ],
        answerId: 2,
        sourceUrl: ''
    },
    {
        questionText: 'What does the term "patient zero" mean?',
        questionType: 'multiple-choice',
        choices: [
            'A person with no symptoms of a disease',
            'A person identified as the first to become infected with an illness or disease in an outbreak',
            'The cost of healthcare if you are infected with the \'Rona'
        ],
        answerId: 1,
        sourceUrl: 'https://www.merriam-webster.com/dictionary/patient%20zero'
    },
    {
        questionText: 'What does the term "flattening the curve" mean?',
        questionType: 'multiple-choice',
        choices: [
            'A terrible exercise trend originating from South Beach, Florida',
            'Slowing the spread of Coronavirus',
            'The earth is flat and those round-earthers are crazy'
        ],
        answerId: 1,
        sourceUrl: 'https://www.yalemedicine.org/stories/covid-19-glossary/'
    },
    {
        questionText: 'During a "shelter-in-place" order, what should I not be doing?',
        questionType: 'multiple-choice',
        choices: [
            'Hang out with friends',
            'Staying in my cozy home',
            'Going for a walk',
            'Work at my essential job'
        ],
        answerId: 0,
        sourceUrl: 'https://www.yalemedicine.org/stories/covid-19-glossary/'
    },
    {
        questionText: 'PPE = ???',
        questionType: 'multiple-choice',
        choices: [
            'Purple People Eaters',
            'Personal Protective Equipment',
            'Promiscuous Personal Exercise'
        ],
        answerId: 1,
        sourceUrl: 'https://www.yalemedicine.org/stories/covid-19-glossary/'
    },
    {
        questionText: 'This is a machine to help patients breathe when their lungs are damaged, and they can’t get enough oxygen on their own.',
        questionType: 'multiple-choice',
        choices: [
            'Vindicator',
            'Vasculator',
            'Ventilator',
            'Valuator'
        ],
        answerId: 2,
        sourceUrl: 'https://www.yalemedicine.org/stories/covid-19-glossary/'
    },
    {
        questionText: 'The brand name of hydroxychloroquine is _______',
        questionType: 'multiple-choice',
        choices: [
            'Plaquenil',
            'Valtrex',
            'Codeine',
            'Hoohasil'
        ],
        answerId: 0,
        sourceUrl: 'https://www.yalemedicine.org/stories/hydroxychloroquine-and-chloroquine-treat-covid-19/'
    }
];
